module.exports = __webpack_public_path__ + "img/poster-1.be1cf68e.jpg";